import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import api from "./lib/api";
import { Toaster } from "./components/ui/sonner";
import { TooltipProvider } from "./components/ui/tooltip";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Feed from "./pages/Feed";
import Matches from "./pages/Matches";
import MatchDetails from "./pages/MatchDetails";
import Admin from "./pages/Admin";
import Pricing from "./pages/Pricing";
import BillingSuccess from "./pages/BillingSuccess";
import Account from "./pages/Account";

function PageTracker() {
  const loc = useLocation();
  useEffect(() => {
    let vid = localStorage.getItem("blinxd_vid");
    if (!vid) {
      vid = window.crypto?.randomUUID?.() || String(Date.now()) + Math.random().toString(36).slice(2);
      localStorage.setItem("blinxd_vid", vid);
    }
    api.post("/analytics/track", { path: loc.pathname, visitor_id: vid, ref: document.referrer || "" }).catch(() => {});
  }, [loc.pathname]);
  return null;
}

function AppRouter() {
  const location = useLocation();
  // Handle Emergent OAuth callback synchronously before any route/auth check
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <PageTracker />
      <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/feed" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
      <Route path="/matches" element={<ProtectedRoute><Matches /></ProtectedRoute>} />
      <Route path="/matches/:matchId" element={<ProtectedRoute><MatchDetails /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><Pricing /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><Account /></ProtectedRoute>} />
      <Route path="/billing/success" element={<BillingSuccess />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <TooltipProvider delayDuration={150}>
            <AppRouter />
            <Toaster
              position="bottom-right"
              toastOptions={{ style: { borderRadius: 0, fontFamily: "JetBrains Mono, monospace" } }}
            />
          </TooltipProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
